<template>
  <div id="error-page">
    <div class="message">
      <h1>Oups ! Je crois que tu t'es perdu...</h1>

      <h3 v-if="isMobile">(Ce jeune éphèbe semble t'indiquer le chemin)</h3>
    </div>
    <div class="bottom">
      <div class="ETimage">
        <img src="https://freepikpsd.com/file/2019/10/et-png-Transparent-Images.png"/>
      </div>
      <div class="home darkTheme bigPaddingRound clickable" @click="$router.replace({name: 'landingPage'})">
        <h1>Maison</h1>
        <img src="https://learnandwatch.s3-accelerate.amazonaws.com/logo2.webp" alt="Learn and Watch">
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
name: "error-404",

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>
  h1{
    font-size: 3em;
    font-weight: bold;
  }

  img {
    display: block;
    padding: 0px;
    margin: 0px;
  }

  #error-page {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
    align-items: center;
    align-content: center;
  }

  .message {
    margin-top: auto;
    text-align: center;
    color: whitesmoke;
  }

  .bottom {
    margin-top: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;
    justify-content: normal;
    align-items: center;
  }

  .home {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (max-device-width: 767px) {
    #error-page {
      overflow: scroll;
    }

    .ETimage img {
      width: 100vw;
    }
  }

</style>